var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ak-type-input',{attrs:{"hideLabel":"","field":_vm.customerField},model:{value:(_vm._value),callback:function ($$v) {_vm._value=$$v},expression:"_value"}})}
var staticRenderFns = []

export { render, staticRenderFns }